import { api, privateApi } from "../apiInstances";
import type { TUser } from "@core/types/TUser";

export async function fetchUser(signal?: AbortSignal): Promise<TUser> {
  const res = await privateApi.get<TUser>("/user/me", { signal });
  return res.data;
}

export const refreshToken = async (): Promise<void> => {
  await api.post("/auth/refresh");
};

export const logout = async (): Promise<void> => {
  await api.post("/user/logout");
};
